import { render, staticRenderFns } from "./detalle-regla.vue?vue&type=template&id=40b52683&scoped=true"
import script from "./detalle-regla.vue?vue&type=script&lang=js"
export * from "./detalle-regla.vue?vue&type=script&lang=js"
import style0 from "./detalle-regla.vue?vue&type=style&index=0&id=40b52683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b52683",
  null
  
)

export default component.exports